@if (totals()) {
<div class="clearfix">
  <dl class="row dl-horizontal">
    <!-- SubTotal -->
    <dt class="col-6">{{ 'checkout.cart.subtotal.heading' | translate }}</dt>
    <dd class="col-6" data-testing-id="basket-subtotal">{{ totals().itemTotal | ishPrice }}</dd>
    <!-- list all applied order level promotions -->
    @if (totals().valueRebates?.length > 0) { @for (rebate of totals().valueRebates; track rebate) { @if
    (rebate?.promotionId) {
    <dt class="col-6">
      <ish-basket-promotion [rebate]="rebate" />
    </dt>
    }
    <dd class="col-6">{{ invert(rebate.amount) | ishPrice }}</dd>
    } }
    <!-- Shipping -->
    <dt class="col-6">
      @if (totals().isEstimated) {
      <span>{{ 'checkout.cart.estimated_shipping_handling.label' | translate }}</span>
      } @if (!totals().isEstimated) {
      <span>{{ 'checkout.order.shipping.label' | translate }}</span>
      }
    </dt>
    <dd class="col-6">{{ totals().undiscountedShippingTotal | ishPrice }}</dd>
    <!-- Shipping promotions -->
    @if (totals().shippingRebates?.length > 0) { @for (rebate of totals().shippingRebates; track rebate) {
    <dt class="col-6">
      <ish-basket-promotion [rebate]="rebate" />
    </dt>
    <dd class="col-6">{{ invert(rebate.amount) | ishPrice }}</dd>
    } }
    <!-- Item Surcharges -->
    @for (surcharge of totals().itemSurchargeTotalsByType; track surcharge) {
    <ng-container *ngTemplateOutlet="surchargeItemTemplate; context: { surcharge: surcharge }" />
    }
    <!-- Bucket Surcharges -->
    @for (surcharge of totals().bucketSurchargeTotalsByType; track surcharge) {
    <ng-container *ngTemplateOutlet="surchargeItemTemplate; context: { surcharge: surcharge }" />
    }
    <!-- Payment costs -->
    @if (hasPaymentCostsTotal) {
    <dt class="col-6">{{ 'checkout.cart.payment_cost.label' | translate }}</dt>
    <dd class="col-6">{{ totals().paymentCostsTotal | ishPrice }}</dd>
    }
    <!-- Tax -->
    @if (totals().taxTotal?.value) {
    <dt class="col-6">{{ taxTranslation$ | async | translate }}</dt>
    <dd class="col-6" data-testing-id="basket-tax">{{ totals().taxTotal | ishPrice }}</dd>
    }
    <!-- Cart total -->
    <dt class="col-6 total-price">
      @if (totals().isEstimated) {
      <span>{{ 'checkout.cart.estimated_total.label' | translate }}</span>
      } @if (!totals().isEstimated) {
      <span>{{ 'checkout.order.total_cost.label' | translate }}</span>
      }
    </dt>
    <dd class="col-6 total-price">{{ totals().total | ishPrice : 'gross' }}</dd>
  </dl>
</div>
}

<!-- surcharge outlet template -->
<ng-template #surchargeItemTemplate let-surcharge="surcharge">
  <ng-template #SurchargeDescription> <span [innerHTML]="surcharge.description"></span> </ng-template>
  <dt class="col-6">
    {{ surcharge.displayName }}
    <a
      class="btn btn-link details-tooltip"
      [ngbPopover]="SurchargeDescription"
      [popoverTitle]="surcharge.displayName"
      placement="top"
    >
      {{ 'shopping_cart.detail.text' | translate }}
      <fa-icon [icon]="['fas', 'info-circle']" />
    </a>
  </dt>
  <dd class="col-6">{{ surcharge.amount | ishPrice }}</dd>
</ng-template>
<!-- <ng-container *ishFeature="'subscription'">
  @if (isLoggedIn$ | async) { @if (isBasketPage$ | async) {
  <custom-lazy-recurring-order-form [toast]="true" />
  } } @if (basket()?.recurrence?.repetitions) {
  <div class="section">
    <dl class="row dl-horizontal dl-separator">
      <dt class="col-6">{{ 'subscriptions.list.table.recurrence' | translate }}</dt>
      <dd class="col-6">{{ basket().recurrence.interval | customSubscriptionIntervalFormatter }}</dd>

      <dt class="col-6">{{ 'account.subscriptiondetails.start_date.label' | translate }}</dt>
      <dd class="col-6">
        {{ basket().recurrence?.startDate | date : 'MM/dd/yy' }}
      </dd>

      <dt class="col-6">{{ 'account.subscriptiondetails.end_date.label' | translate }}</dt>
      <dd class="col-6">
        {{ basket().recurrence?.endDate ? (basket().recurrence?.endDate | date : 'MM/dd/yy') : '-' }}
      </dd>
    </dl>
  </div>
  }
</ng-container> -->
